export default "__VITE_ASSET__CWRixYIQ__"